<div>
  <p>{{'UserPages.UserClosedSale.ModalDescriptionText' | translate}}</p>
  <form [formGroup]="userJoinRequestFormGroup">
    <div class="p-fluid formgrid grid">
      <div class="field col-12" style="margin-bottom: 40px;">
        <label 
          for="guestEmail">
          {{'UserPages.UserClosedSale.EmailModalFieldLabel' | translate}} *
        </label>

        <input 
          pInputText 
          inputId="guestEmail" 
          formControlName="guestEmail" 
          placeholder="{{'UserPages.UserClosedSale.EmailModalFieldPlaceholder' | translate}}"/>

        <small 
          *ngIf="submit && userJoinRequestFormGroup.controls['guestEmail'].invalid" 
          class="p-error">
          {{getErrorMessage('guestEmail')}}
        </small>
      </div>
    </div>
  </form>
  <div class="flex flex-row justify-content-end gap-3">
    <p-button 
      label="{{'UserPages.UserClosedSale.CancelModalButton' | translate}}" 
      (onClick)="onClose()" 
      [loading]="loading"
      styleClass="p-button-outlined w-8rem"/>

    <p-button 
      label="{{'UserPages.UserClosedSale.SendModalButton' | translate}}" 
      (onClick)="saveUserJoinRequest()" 
      [loading]="loading"
      styleClass="w-8rem"/>
  </div>
</div>